import { PageContainer } from '@touche-lts/panel-ui/dist'
import DOMPurify from 'dompurify'
import styles from './terms.module.scss'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useCallback, useEffect, useState } from 'react'
import { LegalStatuses } from 'models/legal-table-entry'
import cl from 'classnames'

const TermsPageComponent = () => {
  const {
    routingStore: { push },
    generalStore: {
      api: {
        legalApi: {
          getTerms
        }
      }
    }
  } = useRootStore(),

  [termsSelected, setTermsSelected] = useState(''),

  [terms, setTerms] = useState([]);

  // handleTemrsChange = (terms: string) => {
  //   setTermsSelected(terms);
  // }

  // declare the async data fetching function
  const fetchTermsPages = useCallback(async () => {
    const termsPage = await getTerms();
    if(!termsPage) return;
    setTerms(termsPage?.content?.filter(term => term?.status === LegalStatuses.ACTIVE));
    if(!!termsPage?.content?.length) {
      setTermsSelected(termsPage?.content[0].content);
    }
  }, [])

  useEffect(() => {
    fetchTermsPages()
      .catch(console.error);
  }, [fetchTermsPages])  

  return (
    <>
      {!!terms.length ? (
        <div className='container mt-5'>
          <div className='row'>
            <div className='col-lg-3'>
              <div className={styles.termsLinks}>
                <h1>All policies</h1>
                {terms?.map(terms => {
                  return(
                    <span onClick={() => setTermsSelected(terms?.content)}>{terms?.title}</span>
                  )
                })}
              </div>
            </div>
            <div className='col-lg-9'>
              <div className={styles.termsBox} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(termsSelected)}}></div>
            </div>
          </div>
        </div>
      ):
      <div className='container mt-5'>
        <div className='row'>
          <div className={cl(styles.termsBox ,"d-flex justify-content-center align-items-center min-vh-70")}>
            <h1>Terms not available.</h1>
        </div>
        </div>
      </div>
      }
    </>
  )
}

const TermsPage = observer(TermsPageComponent)
export { TermsPage }
